const M = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const parts = String(iso).slice(0, 10).split("-").map(Number);
  const [y, m, d] = parts;
  if (!y || !m || !d) return "—";
  return `${d} ${M[m - 1]} ${y}`;
};

const PARTICLES = new Set(["de", "da", "do", "dos", "das", "e"]);
const ACCENTS = {
  andre: "André", jose: "José", joao: "João", antonio: "António", angela: "Ângela", ines: "Inês", monica: "Mónica",
  sonia: "Sónia", barbara: "Bárbara", cecilia: "Cecília", claudia: "Cláudia", lucia: "Lúcia", julia: "Júlia",
  patricia: "Patrícia", marcia: "Márcia", vania: "Vânia", vitor: "Vítor", rogerio: "Rogério", sergio: "Sérgio",
  fabio: "Fábio", flavio: "Flávio", claudio: "Cláudio", marcio: "Márcio", simao: "Simão", sebastiao: "Sebastião",
  conceicao: "Conceição", assuncao: "Assunção", goncalo: "Gonçalo", goncalves: "Gonçalves", simoes: "Simões",
  magalhaes: "Magalhães", guimaraes: "Guimarães", araujo: "Araújo", falcao: "Falcão", brandao: "Brandão",
  leitao: "Leitão", luis: "Luís", luisa: "Luísa", julio: "Júlio", tomas: "Tomás", fatima: "Fátima",
  rosario: "Rosário", tania: "Tânia", debora: "Débora", imoveis: "Imóveis", mediacao: "Mediação", gestao: "Gestão",
  imobiliaria: "Imobiliária", algodao: "Algodão", sa: "Sá",
};
const COMPANY = [
  [/(,?\s+)unipessoal,?\s+(lda|limitada)\.?$/i, ", Unipessoal Lda."],
  [/(,?\s+)(lda|limitada)\.?$/i, ", Lda."],
  [/(,\s*)(s\.?\s?a)\.?$/i, ", S.A."],
  [/(\s+)(s\.\s?a)\.?$/i, ", S.A."],
];
const plain = (s) => s.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
const fmtWord = (w, first) => {
  if (!w) return w;
  if (w !== w.toUpperCase() && w !== w.toLowerCase()) {
    return w.split(/([’'-])/).map((x) => {
      const low = x.toLowerCase();
      return x === low.charAt(0).toUpperCase() + low.slice(1) && ACCENTS[low] ? ACCENTS[low] : x;
    }).join("");
  }
  const l = w.toLowerCase();
  if (!first && PARTICLES.has(l)) return l;
  return l.split(/([’'-])/).map((p) => (/^[’'-]?$/.test(p) ? p : p === plain(p) && ACCENTS[p] ? ACCENTS[p] : p.charAt(0).toUpperCase() + p.slice(1))).join("");
};
export const niceName = (s) => {
  if (!s || !String(s).trim()) return s;
  let t = String(s).trim().replace(/\s+/g, " ");
  let suffix = "";
  for (const [re, form] of COMPANY) {
    const m = t.match(re);
    if (m) { t = t.slice(0, m.index).replace(/[ ,]+$/, ""); suffix = form; break; }
  }
  return t.split(" ").map((w, i) => fmtWord(w, i === 0)).join(" ") + suffix;
};
export const partyName = (x) => x?.display_name || niceName(x?.name);
export const fmtPhone = (s) => {
  if (!s) return s;
  let d = String(s).replace(/\D/g, "");
  if (d.startsWith("00")) d = d.slice(2);
  if (d.length === 9) d = `351${d}`;
  if (d.startsWith("351") && d.length === 12) return `+351 ${d.slice(3, 6)} ${d.slice(6, 9)} ${d.slice(9)}`;
  return d ? `+${d}` : s;
};
const FEM_EXCEPT = new Set(["luca", "joshua", "nikita", "andrea", "jona"]);
export const isFeminine = (x) => {
  if (x?.gender) return /^f/i.test(x.gender);
  const first = plain((partyName(x) || "").split(" ")[0]).toLowerCase();
  return first.endsWith("a") && !FEM_EXCEPT.has(first);
};


export const toInputDate = (iso) => (iso ? String(iso).slice(0, 10) : "");
export const fmtAddress = (a) => (a ? a.split(",").map((part) => part.trim()
  .replace(/\s+(?=(Lote|Bloco|Porta)\s)/gi, ", ")
  .replace(/\s+(?=\d+\s*\.?\s*º)/g, ", ")
  .replace(/(\d+)\s*\.?\s*º\s*/g, "$1.º ").trim()).filter(Boolean).join(", ").replace(/\s*,(\s*,)+/g, ",") : a);


export const fmtCurrency = (n) => {
  if (n == null || n === "") return "—";
  const s = Math.round(Number(n))
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return `${s} €`;
};

export const VERDICT = {
  validado: { label: "Verificado", color: "#16a34a", bg: "#dcfce7", dot: "#16a34a" },
  atencao: { label: "Atenção", color: "#b45309", bg: "#fef3c7", dot: "#f59e0b" },
  problema: { label: "Problema", color: "#b91c1c", bg: "#fee2e2", dot: "#dc2626" },
  aguardar: { label: "A aguardar", color: "#475569", bg: "#f1f5f9", dot: "#94a3b8" },
  renovar: { label: "Renovar com proposta", color: "#1d4ed8", bg: "#dbeafe", dot: "#3b82f6" },
  na: { label: "Não se aplica", color: "#94a3b8", bg: "#f8fafc", dot: "#e2e8f0" },
};

export const SEG_COLOR = {
  validado: "#16a34a",
  atencao: "#f59e0b",
  problema: "#dc2626",
  aguardar: "#cbd5e1",
  na: "#eef1ec",
};

export const STATUS_LABEL = {
  em_falta: "Em falta",
  pedido: "Pedido",
  recebido: "Recebido",
  nao_aplica: "Não se aplica",
};

export const ROLE_LABEL = {
  direccao: "Direção",
  gestor: "Gestão processual",
  consultor: "Consultor",
  platform_admin: "Administrador da plataforma",
};

export const partiesLine = (p) => {
  const sellers = (p.sellers || []).map(partyName).join(" e ");
  const buyers = (p.buyers || []).map(partyName).join(" e ");
  return `${sellers || "—"} vende a ${buyers || "—"} por ${fmtCurrency(p.price)}`;
};
